import React, { useEffect } from "react";
import PeriButton from "../Components/Button";
import background2 from "../../../assets/vietnam/landing-page3-bg2.png"

import '../style/peri-check.css'
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const LandingPage3 = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation("l3")

    // useEffect(() => {
    //     setTimeout(() => {
    //         navigate("/peri-gum/scan")
    //     }, 3500)

    // }, [])

    // Helper function to format Arabic percentages
    const formatArabicText = (text) => {
        if (i18n.language === "ab") {
            // Move percentages to the beginning in Arabic
            return text.replace(/(.+?)(\d+%)(.*)/, '%$2 $1$3');
        }
        return text;
    }

    return (
        <div className="w-full h-screen flex flex-col overflow-hidden">

            <div className="background-image1 p-2">
                <div className="w-full mt-4 p-8 flex flex-col justify-evenly">
                    <p className={`text-peri-secondary text-2xl mt-2 font-bold font-cera-pro-black ${i18n.language === "ab" ? "text-right" : "text-left"}`} dir={i18n.language === "ab" ? "rtl" : "ltr"}>
                        {i18n.language === "ab" ? 
                            <>
                                <span className="text-peri-primary">55%</span> من سكان الشرق الأوسط يعانون من التهاب اللثة
                            </> :
                            <>
                                {t("header1")} <span className="text-peri-primary">{t("header2")}</span>
                            </>
                        }
                    </p>

               

                    <p className={`text-peri-secondary mt-4 font-cera-pro-medium font-[800] ${i18n.language === "ab" ? "text-right" : "text-left"}`} dir={i18n.language === "ab" ? "rtl" : "ltr"}>
                        {i18n.language === "ab" ? 
                            "التهاب اللثة هو المرحلة المبكرة من أمراض اللثة، ويظهر على شكل احمرار، تورّم أو نزيف في اللثة بسبب تراكم البلاك." :
                            <>{t("body1")}<span className="text-peri-primary"> {t("body2")} </span>{t("body3")}</>
                        }
                    </p>

                    <div className={`w-full flex flex-col items-center mt-8`}>
                        <p className={`text-peri-secondary text-xl mb-4 font-cera-pro-medium font-semibold ${i18n.language === "ab" ? "text-right" : "text-left"}`} dir={i18n.language === "ab" ? "rtl" : "ltr"}>
                            {i18n.language === "ab" ? "هل أنت منهم؟" : "Are you one of them?"}
                        </p>
                        <PeriButton 
                            text={t("callToAction")} 
                            icon={
                                <svg 
                                    width="24" 
                                    height="24" 
                                    viewBox="0 0 24 24" 
                                    fill="none" 
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="text-white"
                                >
                                    <path 
                                        d="M23 19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V8C1 6.89543 1.89543 6 3 6H7L9 4H15L17 6H21C22.1046 6 23 6.89543 23 8V19Z" 
                                        stroke="currentColor" 
                                        strokeWidth="2" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round"
                                    />
                                    <circle 
                                        cx="12" 
                                        cy="13" 
                                        r="4" 
                                        stroke="currentColor" 
                                        strokeWidth="2"
                                    />
                                </svg>
                            }
                            onClick={() => navigate("/expert/scan")} 
                        />
                    </div>
                </div>
            </div>

            <div
                className="flex-1 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${background2})` }}
            />
        </div>

    );
};

export default LandingPage3;